import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { DEFERRED_CHART_PLACEHOLDER_HEIGHT, DEFERRED_CHART_ROOT_MARGIN } from './constants';

// Renders children only once the slot nears the viewport, so off-screen KPI charts
// are not mounted up front. Stays mounted after first reveal to preserve chart state (zoom, series visibility).
const DeferredChart = ({ children, placeholderHeight, rootMargin }) => {
    const slotRef = useRef(null);
    const [isRevealed, setIsRevealed] = useState(false);

    useEffect(() => {
        if (isRevealed) { return undefined; }

        const node = slotRef.current;
        if (!node || typeof IntersectionObserver === 'undefined') {
            setIsRevealed(true);
            return undefined;
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) {
                setIsRevealed(true);
                observer.disconnect();
            }
        }, { rootMargin });

        observer.observe(node);
        return () => observer.disconnect();
    }, [isRevealed, rootMargin]);

    return (
        <div ref={slotRef} className='deferred-chart-slot'>
            {isRevealed
                ? children
                : <div className='deferred-chart-placeholder' style={{ height: placeholderHeight }} />}
        </div>
    );
};

DeferredChart.propTypes = {
    children: PropTypes.node,
    placeholderHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rootMargin: PropTypes.string
};

DeferredChart.defaultProps = {
    placeholderHeight: DEFERRED_CHART_PLACEHOLDER_HEIGHT,
    rootMargin: DEFERRED_CHART_ROOT_MARGIN
};

export default DeferredChart;
